<script>
import { watch } from 'vue';
import pdfMake from "pdfmake/build/pdfmake";
import { pdfFileName, openPdf } from '@/utils/pdfFile';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import shopServices from '@/services/ShopServices';
import moment from 'moment';
export default {
  props: {
    trigger: Number,
  },
  setup(props, { emit }) {
    const loadPdf = async () => {
      try {
        const response = await shopServices.getShopsPdf();
        const pdfData = response.data.data || [];

        if (!pdfData.length) {
          emit('alertEvent', 'no_data');
          return;
        }

        const body = [
          [
            { text: '#', style: 'defaultFont', alignment: 'center' },
            { text: 'Shop Name', style: 'defaultFont', alignment: 'center' },
            { text: 'Owner Name', style: 'defaultFont', alignment: 'center' },
            { text: 'Mobile', style: 'defaultFont', alignment: 'center' },
            { text: 'City', style: 'defaultFont', alignment: 'center' },
            { text: 'Address', style: 'defaultFont', alignment: 'center' },
            { text: 'Salesman', style: 'defaultFont', alignment: 'center' },
            { text: 'Remain', style: 'defaultFont', alignment: 'center' },
          ],
        ];

        let index = 1;
        pdfData.forEach((row) => {
          const salesmen = Array.isArray(row.salesmen) ? row.salesmen : [];
          const salesmanNames = salesmen
            .map((salesman) => salesman.name || '')
            .join('\n');
          const salesmanRemaining = salesmen
            .map((salesman) =>
              salesman.remaining_amount !== null && salesman.remaining_amount !== undefined
                ? salesman.remaining_amount.toString()
                : ''
            )
            .join('\n');

          body.push([
            { text: index.toString(), style: 'defaultFont', alignment: 'center' },
            // Shop name stands out: bold and a size larger than the rest.
            { text: row.shop_name || '', style: ['defaultFont', 'shopName'], alignment: 'left' },
            { text: row.owner_name || '', style: 'defaultFont', alignment: 'left' },
            { text: row.mobile || '', style: 'defaultFont', alignment: 'center' },
            { text: row.city || '', style: 'defaultFont', alignment: 'left' },
            { text: row.address || '', style: 'defaultFont', alignment: 'left' },
            { text: salesmanNames, style: 'defaultFont', alignment: 'left' },
            { text: salesmanRemaining, style: 'defaultFont', alignment: 'center' },
          ]);

          index += 1;
        });

        const documentDefinition = {
          pageOrientation: 'landscape',
          pageSize: 'A4',
          pageMargins: [25, 25, 25, 25],
          content: [
            {
              columns: [
                {
                  width: '50%',
                  text: 'Shopkeepers',
                  style: ['defaultFont', 'mb2'],
                },
              ],
            },
            {
              columns: [
                {
                  width: '50%',
                  text: 'Print Date : ' + moment().format('DD/MM/YY'),
                  style: ['defaultFont', 'textLeft', 'mb15'],
                },
              ],
            },
            {
              table: {
                headerRows: 1,
                // Fit the full landscape width: fixed columns, Address takes the rest.
                // Owner Name narrower, City wider so town names fit on one line.
                widths: [22, 120, 80, 70, 85, '*', 120, 60],
                body,
              },
            },
          ],
          styles: {
            defaultFont: {
              fontSize: 9,
              bold: true,
            },
            shopName: {
              fontSize: 11,
              bold: true,
            },
            textLeft: {
              alignment: 'left',
            },
            mb2: {
              margin: [0, 0, 0, 2],
            },
            mb15: {
              margin: [0, 0, 0, 15],
            },
          },
        };

        pdfMake.vfs = pdfFonts;
        openPdf(pdfMake, documentDefinition, pdfFileName(['Shopkeepers'], ''));
      } catch (error) {
        emit('alertEvent', 'no_data');
      }
    };

    watch(
      () => props.trigger,
      (currentValue, previousValue) => {
        if (currentValue !== previousValue) {
          loadPdf();
        }
      }
    );

    return {
      loadPdf,
    };
  },
};
</script>
